// Todo: this file need to be refactored
import '../../../plugins/stickyElements/js/stickyElements';
import 'element-closest-polyfill';

$(function () {
    const skipButtons = document.querySelectorAll('.skip-links button');
    if (skipButtons.length) {
        const handleSkip = e => {
            const targetId = e.currentTarget.getAttribute('data-id');
            const skipTo = document.querySelector(targetId);
            const elementRect = skipTo?.getBoundingClientRect();

            window.scrollTo({
                top: elementRect.top + window.scrollY, // Add the current scroll position
                behavior: 'smooth', // Use smooth scrolling
            });
            skipTo.focus();
        };

        skipButtons.forEach(button => {
            button.addEventListener('click', handleSkip);
        });
    }

    $('.logo-container a, .logo-container-mobile a, .institution > a').attr('tabindex', '2');

    $('.indivLogin').on('click', function () {
        setTimeout(() => {
            $(this).attr('aria-expanded', !$('.navigation-login-dropdown-container').hasClass('hidden'));
        }, 0);
    });
    $(document).on('click', function () {
        setTimeout(() => {
            $('.indivLogin').attr('aria-expanded', !$('.navigation-login-dropdown-container').hasClass('hidden'));
        }, 0);
    });

    let vPort = 'screen-md',
        institutionWrapperMobile = $('.institution-wrapper-mobile'),
        institutionWrapperDesktop = $('.institution-wrapper'),
        isMobile = false;

    institutionWrapperDesktop.removeAttr('aria-hidden');
    institutionWrapperMobile.attr('aria-hidden', 'true');

    $(document).on(vPort + '-on', function () {
        isMobile = true;
        institutionWrapperDesktop.attr('aria-hidden', 'true');
        institutionWrapperMobile.removeAttr('aria-hidden');
    });

    $(document).on(vPort + '-off', function () {
        isMobile = false;
        institutionWrapperDesktop.removeAttr('aria-hidden');
        institutionWrapperMobile.attr('aria-hidden', 'true');
    });

    if ($('.pb-ui').length && $('[aria-haspop]').length) {
        $.each($('[aria-haspop]'), function (index, $item) {
            $($item).removeAttr('aria-haspop').attr('aria-haspopup', 'true');
        });
    }

    $(window).on('load orientationchange', function () {
        if ($('.fixed-element').length) {
            isMobile &&
                setTimeout(function () {
                    UX.stickyElements.init();
                }, 150);
        }
    });

    $(window).on('resize', function () {
        if ($('.fixed-element').length) {
            UX.stickyElements.init();
        }
    });

    const removeBackdropEl = () => {
        const modalBackdropList = UX.utils.convertToArray(document.querySelectorAll('.modal-backdrop.in'));
        modalBackdropList.forEach(item => {
            const itemParent = item.parentNode;
            itemParent.removeChild(item);
        });
    };

    const modalCloseButtons = UX.utils.convertToArray(document.querySelectorAll('.modal__dialog .close'));
    if (modalCloseButtons.length) {
        modalCloseButtons.forEach(button => {
            button.addEventListener('click', e => {
                removeBackdropEl();
            });
        });
    }

    const modalList = UX.utils.convertToArray(document.querySelectorAll('.modal'));
    if (modalList.length) {
        modalList.forEach(modal => {
            modal.addEventListener('click', e => {
                if (e.target === e.currentTarget) {
                    removeBackdropEl();
                }
            });
        });
    }

    document.addEventListener('keydown', e => {
        const modalBackdropList = UX.utils.convertToArray(document.querySelectorAll('.modal-backdrop.in'));
        if (modalBackdropList.length && e.key.indexOf('Esc') > -1) {
            modalBackdropList.forEach(item => {
                const itemParent = item.parentNode;
                itemParent.removeChild(item);
            });
            if (UX.modal.$close) UX.modal.$close.trigger('click');
        }
    });

    const fixedSwitchEl = document.querySelector('.js--fixed-switch'),
        scrollableEl = fixedSwitchEl && fixedSwitchEl.querySelector('.scrollable-element');

    if (fixedSwitchEl && scrollableEl) {
        if (UX.test.isIE()) {
            const scrollableParent = scrollableEl.parentElement,
                paddingAmount = scrollableEl.offsetHeight,
                elTop = scrollableEl.offsetTop,
                scrollableParentPadding = scrollableParent.style.paddingTop,
                setScrollStatus = () => {
                    if (window.pageYOffset > elTop && !scrollableEl.classList.contains('js--fixed')) {
                        scrollableEl.classList.add('js--fixed');
                        scrollableParent.style.paddingTop = `${paddingAmount}px`;
                    } else if (window.pageYOffset <= elTop && scrollableEl.classList.contains('js--fixed')) {
                        scrollableEl.classList.remove('js--fixed');
                        scrollableParent.style.paddingTop = scrollableParentPadding;
                    }
                };

            setScrollStatus();
            window.addEventListener('scroll', setScrollStatus);
        } else {
            fixedSwitchEl.classList.add('fixed-element');
            scrollableEl.classList.add('scrollThenFix');
            UX.stickyElements.init();
        }
    }

    const advertRail = UX.utils.convertToArray(document.querySelectorAll('.advert-rail, .advert-leaderboard'));

    if (advertRail.length) {
        const hideAdsIfCorrupted = () => {
            advertRail.forEach(item => {
                setTimeout(() => {
                    if (typeof item.dataset.googleQueryId === 'undefined' && item.style.display !== 'none') {
                        item.style.display = 'none';
                    }
                }, 1000);
            });
        };

        window.addEventListener('load', hideAdsIfCorrupted);
    }

    const showRequestResetPasswordBtn = document.querySelector('.show-request-reset-password');
    showRequestResetPasswordBtn?.addEventListener('click', () => {
        const reCaptcha = document.querySelector('.g-recaptcha');
        if (reCaptcha) {
            const reCaptchaRoot = reCaptcha.parentNode;
            reCaptcha.remove();
            setTimeout(() => {
                reCaptchaRoot?.append(reCaptcha);
            }, 5000);
        }
    });

    const adverts = Array.from(document.querySelectorAll('.pb-las .advert'));

    if (adverts) {
        setTimeout(() => {
            adverts.forEach(advert => {
                advert.className += ' advert--no-spinner';
            });
        }, 3000);
    }
});
